<template>
  <div>
    <card class="card" title="Edit Credentials">
      <div class="card__right-button">
        <div class="position-relative">
          <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openModalCreate()">
            <i class="fas fa-plus"></i>
          </button>
          <div class="tooltipCustom tooltipCustom--bottom">Create new Credential</div>
        </div>
      </div>
      <div>
        <form @submit.prevent>
          <div v-for="(credential, index) in credentials" v-bind:key="index">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-xl-3">
                <fg-input type="text" label="Username" placeholder="Username" v-model="credential.data.username">
                </fg-input>
              </div>
              <div class="col-sm-12 col-md-4 col-xl-3">
                <fg-input
                  type="text"
                  :disabled="true"
                  label="Valid until"
                  placeholder="Valid until"
                  v-model="credential.data.valid_until"
                >
                </fg-input>
              </div>
              <div class="col-sm-12 col-md-4 col-xl-3">
                <fg-input
                  type="text"
                  :disabled="true"
                  label="Created at"
                  placeholder="Last Name"
                  v-model="credential.data.created_at"
                >
                </fg-input>
              </div>
              <div class="col-xl-3 button-group mt-3">
                <div class="position-relative">
                  <button
                    class="btn btn-just-icon btn-outline-success mr-3 tooltipBtn"
                    @click="updateUsername(credential)"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                  <div class="tooltipCustom tooltipCustom--bottom">Save</div>
                </div>
                <div class="position-relative">
                  <button
                    class="btn btn-just-icon btn-outline-primary mr-3 tooltipBtn"
                    @click="openModalReset(credential)"
                  >
                    <i class="fas fa-key"></i>
                  </button>
                  <div class="tooltipCustom tooltipCustom--bottom">Reset Password</div>
                </div>
                <div class="position-relative">
                  <button
                    class="btn btn-just-icon btn-outline-danger mr-3 tooltipBtn"
                    @click="openModalDelete(credential, index)"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                  <div class="tooltipCustom tooltipCustom--bottom">Delete</div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>

    <!--    Modals -->
    <ModalTemplate
      component-name="CreateCredentialModal"
      button-component-name="CreateNewButton"
      action="createCredential"
      :clicked="openCreate"
      :data="{
        user: user,
        content: 'createCredential',
        submitTitle: $t('createNewCredentials'),
        header: $t('createNewCredentials'),
      }"
      @submit="updateListCredentials($event)"
      @update:field="openCreate = false"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="PasswordModal"
      button-component-name="ResetButton"
      :clicked="openReset"
      :data="{ credential: chosen_credential }"
      :button_data="{
        title: $t('resetPassword'),
        name: $t('resetPassword'),
      }"
      @update:field="openReset = false"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      :clicked="openDelete"
      action="deleteCredential"
      :data="{
        deletion_object_name: this.chosen_credential.data.username,
        deletion_object_text: $t('thisCredentials'),
        delete_button_title: $t('deleteCredentials'),
        header: $t('deleteCredentials'),
      }"
      @submit="deleteCredential()"
      @update:field="openDelete = false"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
import axiosAuth from '../../../axiosMain';
export default {
  components: { ModalTemplate },
  props: {
    user: {
      type: Object,
    },
    credentials: {
      type: Array,
    },
  },
  data() {
    return {
      openCreate: false,
      openReset: false,
      openDelete: false,
      chosen_credential: {
        data: {
          username: null,
        },
      },
      credential_index: null,
    };
  },
  methods: {
    updateUsername(credential) {
      this.$emit('updateUsername', credential);
    },
    updateListCredentials: function (event) {
      this.credentials.push(event);
    },
    openModalCreate() {
      this.openCreate = true;
    },
    openModalReset(credential) {
      this.chosen_credential = credential;
      this.openReset = true;
    },
    openModalDelete(credential, index) {
      this.setCredentialForDeletion(credential, index);
    },
    deleteCredential: function () {
      axiosAuth
        .delete('/credentials/' + this.chosen_credential.data.credential_id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.removeCredential();
          this.$notify({
            type: 'success',
            title: 'Success!',
            text: 'Credentials were deleted',
          });
        });
    },
    removeCredential: function () {
      this.credentials.splice(this.credential_index, 1);
    },

    setCredentialForDeletion: function (credential, index) {
      this.chosen_credential = credential;
      this.credential_index = index;
      this.openDelete = true;
    },
  },
};
</script>
<style></style>
